import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const RampCurvesTooltipContent = () => {
  const { t } = useTranslation()

  return (
    <Box sx={{ maxWidth: 300 }}>
      <Typography sx={{ mb: 1, fontWeight: 'bold' }} variant="body2">
        {t('resources.ramp_curves.tooltip.title')}
      </Typography>
      <Typography sx={{ mb: 1 }} variant="body2">
        {t('resources.ramp_curves.tooltip.description')}
      </Typography>
      <Typography sx={{ mb: 1 }} variant="body2">
        {t('resources.ramp_curves.tooltip.entries_description')}
      </Typography>
      <Typography variant="body2">{t('resources.ramp_curves.tooltip.direction_description')}</Typography>
    </Box>
  )
}

export default RampCurvesTooltipContent
